import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  header: {
    minHeight: 64,
  },
  divider: {
    margin: 0,
    marginBottom: theme.spacing(2),
  },
}));
